import React from 'react';
import { useNavigate } from 'react-router-dom';

function About() {
  const navigate = useNavigate();

  const handleNavigateBack = () => {
    navigate(-1)
  }

  const jlrImage = "/assets/about/jlr.png";
  const backgroundImage = "/assets/about/background2.jpg";
  const jlrImage2 = "/assets/about/background-mobile.jpg";

  return (
    <div id="about" className="site-page about relative max-w-[1920px] mx-auto overflow-x-hidden">
      <div className="hidden xl:block absolute inset-0 w-full h-[calc(100vh-80px)] -z-[1] pointer-events-none">
        <img
          src={backgroundImage}
          className="absolute inset-0 w-full h-full object-cover"
          alt=""
        />
      </div>
      <div className="hidden xl:block absolute top-0 right-[3%] w-[36%] h-[calc(100vh-80px)] z-10 pointer-events-none">
        <img
          src={jlrImage}
          className="absolute inset-0 w-full h-full object-contain object-bottom animate-slideLeft"
          alt="Jovy Rabelas Profile"
        />
        {/* <div
          className="absolute inset-y-0 left-0 w-1/4 bg-gradient-to-r from-white to-white/0"
          aria-hidden="true"
        /> */}
      </div>
      <div className="container relative mx-auto mt-[72px] xl:h-[calc(100vh-152px)] portrait:h-[calc(100vh-152px)] h-inherit">
        <div className="w-full h-full xl:absolute inset-0 -z[1]">
          <div className="grid grid-cols-12 h-full">
            <div className="xl:col-span-8 col-span-12 md:px-5 flex flex-col xl:justify-center portrait:justify-end xl:mb-10">
              <button onClick={handleNavigateBack} className='flex items-center mt-10 w-fit xl:text-white px-5'>
                <svg width="10" height="26" viewBox="0 0 15 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M14.2678 0.761522C15.2441 1.77689 15.2441 3.42311 14.2678 4.43848L6.03553 13L14.2678 21.5615C15.2441 22.5769 15.2441 24.2231 14.2678 25.2385C13.2915 26.2538 11.7085 26.2538 10.7322 25.2385L0.732233 14.8385C-0.244078 13.8231 -0.244078 12.1769 0.732233 11.1615L10.7322 0.761522C11.7085 -0.253841 13.2915 -0.253841 14.2678 0.761522Z" fill="black" className="xl:fill-white" />
                </svg>
                <div className="sm:text-xl text-lg font-bold ml-3">BACK</div>
              </button>
              <div className='flex mt-5 flex-col xl:min-h-0 xl:overflow-y-auto xl:text-white p-5 rounded-lg xl:bg-[rgba(28,15,15,0.80)]'>
                {/* <div className="sm:text-3xl text-lgtext-[#b81618] font-bold sm:mb-5 mb-2 xs:mt-0 mt-5">About</div> */}
                <div className="sm:text-3xl text-xl font-medium mb-5 md:mt-5 opacity-0 animate-fadeInUp">Building with Purpose</div>
                <div className="sm:text-xl text-lg font-medium mb-5 opacity-0 animate-fadeInUpDelay">Building isn't just about creating businesses. It's about creating opportunities that make a lasting difference</div>
                <div className='xl:hidden block mb-5 opacity-0 animate-fadeInUpDelay2'>
                  <picture>
                    <source media="(max-width: 768px)" srcSet={jlrImage2} />
                    <img
                      src={jlrImage2}
                      className='w-full h-auto'
                      alt="Jovy Rabelas Profile"
                    />
                  </picture>
                </div>
                <div className='sm:text-base text-sm xl:text-white mb-5 opacity-0 animate-fadeInUpDelay2'>
                  <p className='mb-5'>
                    Meaningful growth happens when strategy, creativity, technology, and people come together with a shared purpose. That belief has shaped every organization I've helped build, every brand I've partnered with, and every experience I've had the privilege to create.
                  </p>
                  <p className='mb-5'>
                    Today, it continues to guide my work through Creative Engineering— a philosophy that transforms ideas into meaningful impact.
                  </p>
                  <p>
                    Whether through business, leadership, or community initiatives, my goal remains the same: <br className="md:block hidden" />to build organizations that create value, empower people, and leave the future better than we found it.
                  </p>

                </div>
                {/* <div className="flex gap-4 sm:mt-10 mt-5 md:mb-10 mb-5">
                  <a href="https://tagline.com.ph/" target='_blank' rel="noopener noreferrer">
                    <img src="/image/tagline-group-logo-2.png" className='sm:w-[105px] w-[75px]' alt="Tagline Group" />
                  </a>
                  <a href="https://tagline360.com/" target='_blank' rel="noopener noreferrer">
                    <img src="/image/tagline360-logo-2.png" className='sm:w-[105px] w-[75px]' alt="Tagline 360" />
                  </a>
                </div> */}
              </div>
            </div>
            <div className="lg:col-span-4 col-span-12 lg:pt-0 pt-10 h-full relative">
              {/* <img src="/image/jlr-photo3.png" className='ml-auto max-w-[104.5%] md:absolute bottom-0 -right-[20%]' alt="Jovy Rabelas Profile" /> */}
              {/* <div className='md:w-[445px] h-full border'> */}
              {/* <div className='jlr-profile h-full'> */}
              {/* <div className='jlr-profile h-full ml-auto'> */}
            </div>
          </div>
        </div>
      </div>


    </div>
  );
}

export default About;

